import InputLabel from '@mui/material/InputLabel';
import { LabelStyled } from '../Labels';
import { InputStyled } from '../InputStyled';
import { FormControl } from '@mui/material';
import * as React from 'react';
import { useMemo } from 'react';
import { OutlinedInputProps } from '@mui/material/OutlinedInput/OutlinedInput';

import styles from './styles.module.scss';

type InputProps = {
  label: string;
  required?: boolean;
  inputProps: OutlinedInputProps;
  error?: string;
  errorMessage?: string;
  disabled?: boolean;
};

export const CustomFormControl = ({
  label,
  required,
  inputProps,
  error,
  errorMessage,
  disabled = false,
}: InputProps) => {
  const id = useMemo(() => {
    return label.replace(' ', '-').toLowerCase();
  }, [label]);

  return (
    <FormControl sx={{ m: 0, p: 0, width: '100%' }} disabled={disabled}>
      <InputLabel
        htmlFor={id}
        color="secondary"
        classes={{
          root: styles.label,
          focused: styles.labelFocused,
          shrink: styles.labelFocused,
        }}
      >
        <LabelStyled required={required}>{label}</LabelStyled>
      </InputLabel>
      <InputStyled id={id} error={!!error} {...inputProps} />
      <span style={{ color: '#ff0035', fontSize: '12px' }}>{errorMessage}</span>
    </FormControl>
  );
};
